
/**
 * ButtonStylesProcessor - Creates styles specific to button elements
 */
export class ButtonStylesProcessor {
  static createButtonStyles(): string {
    return `
      /* Button styles - critical for visibility */
      .onexip-calculator-container button {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 0.5rem !important;
        padding: 0.5rem 1rem !important;
        border-radius: 0.375rem !important;
        font-weight: 500 !important;
        font-size: 0.875rem !important;
        line-height: 1.5 !important;
        cursor: pointer !important;
        transition: background-color 0.2s, color 0.2s, opacity 0.2s !important;
        background-color: #FB923C !important;
        color: white !important;
        border: none !important;
        outline: none !important;
        min-height: 2.5rem !important;
      }

      .onexip-calculator-container button[data-variant="outline"] {
        background-color: transparent !important;
        color: #0f172a !important;
        border: 1px solid #d4d4d8 !important;
      }

      /* Button states */
      .onexip-calculator-container button:hover:not(:disabled) {
        opacity: 0.9 !important;
      }

      .onexip-calculator-container button:focus-visible {
        outline: 2px solid #FB923C !important;
        outline-offset: 2px !important;
      }

      .onexip-calculator-container button:disabled {
        opacity: 0.5 !important;
        cursor: not-allowed !important;
      }
      
      /* Fix for ShadCN button styles in web component */
      .onexip-calculator-container .bg-primary {
        background-color: #FB923C !important;
      }
      
      .onexip-calculator-container .text-primary-foreground {
        color: white !important;
      }
      
      .onexip-calculator-container .hover\\:bg-primary\\/90:hover {
        background-color: rgba(251, 146, 60, 0.9) !important;
      }
    `;
  }
}
